export const STYLES = {
  DialogPaperProps: {
    sx: {
      maxHeight: "100vh",
      // height: `calc(100vh - 32px)`,
      height: `calc(100vh)`,
      p: 0,
      m: 0,
      width: "100vw",
      maxWidth: "100vw",
      position: "fixed",
      bottom: 0,
      overflow: "hidden",
      borderRadius: "12px 12px 0 0",
      backgroundColor: "primary.light",
    } as const,
  },
  DialogSlotProps: {
    backdrop: {
      sx: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      } as const,
    },
  },
  dialogContent: {
    width: "100%",
    height: "100%",
    mx: "auto",
    p: 0,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  } as const,
  bottomBarContainer: {
    position: "sticky",
    bottom: 0,
    right: 0,
    left: 0,
    margin: "0 auto",
    width: "100%",
    zIndex: 10,
    backgroundColor: "primary.light",
    display: "flex",
    justifyContent: "center",
  } as const,
};
